import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import FieldText from "./FieldText";
// Find all placeholder elements on the page
const componentPlaceholders = document.querySelectorAll('.rc-field-text');
componentPlaceholders.forEach(divElement => {
    const target = divElement;
    if (target) {
        const componentID = target.dataset.componentId;
        const inputName = target.dataset.name;
        const titleLabel = target.dataset.titleLabel;
        const subtitleLabel = target.dataset.subtitleLabel;
        const placeholder = target.dataset.placeholder;
        const inputValue = target.dataset.value;
        const feedbackMessage = target.dataset.feedbackMessage;
        const isRequired = (target.dataset.isRequired === "true") ? true : false;
        const root = createRoot(target);
        root.render(_jsx(FieldText, { componentID: componentID, inputName: inputName, titleLabel: titleLabel, subtitleLabel: subtitleLabel, placeholder: placeholder, inputValue: inputValue, feedbackMessage: feedbackMessage, isRequired: isRequired }));
    }
});
